module.exports = __webpack_public_path__ + "img/暨南大学-300x300.6fa0a0d2.jpg";